import { useMutation } from '@tanstack/react-query';
import type { EmailNotificationSettingsDto } from '../../../models/settings/admin/email-notification-settings.dto';
import apiRequest from '../../../services/apiWrapper';
import { EMAIL_NOTIFICATION_URL } from '../../../utils/constants/urlConstants';

async function updateEmailNotificationSettings(
  data: EmailNotificationSettingsDto
) {
  return apiRequest.put(EMAIL_NOTIFICATION_URL, data);
}

export function useUpdateEmailNotificationSettings() {
  return useMutation({
    mutationFn: (data: EmailNotificationSettingsDto) =>
      updateEmailNotificationSettings(data),
  });
}
